var _, createFilterBar, createOption, detailsTemplate, getAttributeChoices, getFilters, inPopState, itemTemplate, jQuery, keyDifference, optionTemplate, parseFilterString, splitFilterString, trimEmpty, ui, unParseFilters, updateURL,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

jQuery = require('jquery');

_ = require('underscore');

require('selectize');

ui = require('evesrp/common-ui');

optionTemplate = require('evesrp/templates/filter_option');

itemTemplate = require('evesrp/templates/filter_item');

detailsTemplate = require('evesrp/templates/filter_create');

getAttributeChoices = function(attribute) {
  var data, promise;
  if (attribute === 'status') {
    promise = jQuery.Deferred();
    promise.resolve({
      key: 'status',
      status: ['evaluating', 'approved', 'rejected', 'incomplete', 'paid']
    });
    return promise;
  } else if (attribute === 'details' || attribute === 'submit_timestamp' || attribute === 'kill_timestamp') {
    promise = jQuery.Deferred();
    data = {
      key: attribute
    };
    data[attribute] = null;
    promise.resolve(data);
    return promise;
  } else {
    return jQuery.ajax({
      type: 'GET',
      url: scriptRoot + "/api/filter/" + attribute + "/"
    });
  }
};

trimEmpty = function(arrayOrObject) {
  var array, j, key, len, object, ref, value;
  if (_.isArray(arrayOrObject)) {
    array = arrayOrObject;
    if (array[0] === '') {
      array = array.slice(1);
    }
    if (array.slice(-1)[0] === '') {
      array = array.slice(0, -1);
    }
    return array;
  } else {
    object = {};
    ref = _.keys(arrayOrObject);
    for (j = 0, len = ref.length; j < len; j++) {
      key = ref[j];
      value = arrayOrObject[key];
      if (_.isArray(value)) {
        if (value.length !== 0) {
          object[key] = value;
        }
      } else if (_.isString(value)) {
        if (value !== '') {
          object[key] = value;
        }
      } else if (!_.isUndefined(value)) {
        object[key] = value;
      }
    }
    return object;
  }
};

keyDifference = function(obj1, obj2) {
  var j, key, keys1, keys2, len, ref, results;
  obj1 = trimEmpty(obj1);
  obj2 = trimEmpty(obj2);
  keys1 = _.keys(obj1);
  keys2 = _.keys(obj2);
  results = _.union(_.difference(keys1, keys2), _.difference(keys2, keys1));
  ref = _.intersection(keys1, keys2);
  for (j = 0, len = ref.length; j < len; j++) {
    key = ref[j];
    if (!_.isEqual(obj1[key], obj2[key])) {
      results.push(key);
    }
  }
  return results;
};

splitFilterString = function(pathname) {
  var filterPath, knownAttributes, queryIndex;
  filterPath = pathname.split('/');
  filterPath = trimEmpty(filterPath);
  knownAttributes = ['page', 'division', 'alliance', 'corporation', 'pilot', 'system', 'constellation', 'region', 'ship', 'status', 'details', 'sort', 'payout', 'base_payout', 'submit_timestamp', 'kill_timestamp'];
  queryIndex = _.findIndex(filterPath, (function(entry) {
    return indexOf.call(knownAttributes, entry) >= 0;
  }));
  if (queryIndex !== -1) {
    return [filterPath.slice(0, queryIndex).join('/'), filterPath.slice(queryIndex).join('/')];
  } else {
    return [filterPath.join('/'), ''];
  }
};

parseFilterString = function(filterString) {
  var attr, filters, i, splitString, values;
  filters = {};
  filters = _.defaults(filters, {
    page: 1,
    sort: '-submit_timestamp'
  });
  if (filterString === void 0 || filterString === '') {
    return filters;
  }
  splitString = filterString.split('/');
  splitString = trimEmpty(splitString);
  if (splitString.length % 2 !== 0) {
    return filters;
  }
  i = 0;
  while (i < splitString.length) {
    attr = splitString[i].toLowerCase();
    values = decodeURIComponent(splitString[i + 1]);
    if (!(attr in filters)) {
      filters[attr] = [];
    }
    switch (attr) {
      case 'details':
        filters.details = _.union(filters[attr], [values]);
        break;
      case 'page':
        filters.page = parseInt(values, 10);
        break;
      case 'sort':
        filters.sort = values;
        break;
      default:
        if (indexOf.call(values, ',') >= 0) {
          values = values.split(',');
        } else {
          values = [values];
        }
        filters[attr] = _.union(filters[attr], values);
    }
    i += 2;
  }
  return filters;
};

unParseFilters = function(filters) {
  var attr, details, filterStrings, keys, value, values;
  filters = trimEmpty(filters);
  keys = _.keys(filters);
  keys.sort();
  filterStrings = (function() {
    var j, len, results1;
    results1 = [];
    for (j = 0, len = keys.length; j < len; j++) {
      attr = keys[j];
      values = filters[attr];
      switch (attr) {
        case 'details':
          details = (function() {
            var k, len1, results2;
            results2 = [];
            for (k = 0, len1 = values.length; k < len1; k++) {
              value = values[k];
              results2.push("details/" + value);
            }
            return results2;
          })();
          results1.push(details.join('/'));
          break;
        case 'page':
        case 'sort':
          results1.push(attr + "/" + values);
          break;
        default:
          values.sort();
          values = values.join(',');
          results1.push(attr + "/" + values);
      }
    }
    return results1;
  })();
  return filterStrings.join('/');
};

getFilters = function() {
  var basePath, filterPath, ref;
  if (!_.isEmpty(typeof history !== "undefined" && history !== null ? history.state : void 0)) {
    return history.state;
  }
  ref = splitFilterString(window.location.pathname), basePath = ref[0], filterPath = ref[1];
  return parseFilterString(filterPath);
};

updateURL = function(filters) {
  var basePath, diffKeys, filterPath, filtersPath, oldFilters, ref, ref1;
  if (_.isString(filters)) {
    ref = splitFilterString(filters), basePath = ref[0], filterPath = ref[1];
    filters = parseFilterString(filterPath);
  }
  oldFilters = getFilters();
  if (_.isEqual(oldFilters, filters)) {
    return;
  }
  diffKeys = keyDifference(oldFilters, filters);
  if (indexOf.call(diffKeys, 'page') < 0) {
    filters.page = 1;
  }
  ref1 = splitFilterString(window.location.pathname), basePath = ref1[0], filterPath = ref1[1];
  filtersPath = unParseFilters(filters);
  history.pushState(filters, null, "/" + basePath + "/" + filtersPath);
  return (jQuery(window)).trigger('evesrp:filterchange');
};

inPopState = false;

createOption = function(value, attribute, sign) {
  var translatedAttribute;
  translatedAttribute = ui.attributeGettext(attribute);
  return {
    realValue: value,
    attribute: attribute,
    sign: sign,
    display: translatedAttribute + ":" + sign + value
  };
};

createFilterBar = function(selector) {
  var attributes, itemsFromFilter;
  attributes = ['pilot', 'corporation', 'alliance', 'system', 'constellation', 'region', 'ship', 'status', 'division', 'details', 'submit_timestamp', 'kill_timestamp'];
  itemsFromFilter = function(filter) {
    var attribute, items, j, k, len, len1, ref, ref1, translatedAttribute, value;
    items = [];
    for (j = 0, len = attributes.length; j < len; j++) {
      attribute = attributes[j];
      if (attribute in filter) {
        ref = filter[attribute];
        for (k = 0, len1 = ref.length; k < len1; k++) {
          value = ref[k];
          translatedAttribute = ui.attributeGettext(attribute);
          if ((ref1 = value.charAt(0)) !== '=' && ref1 !== '-' && ref1 !== '<' && ref1 !== '>') {
            items.push(translatedAttribute + ":=" + value);
          } else {
            items.push(translatedAttribute + ":" + value);
          }
        }
      }
    }
    return items;
  };
  return ui.setupTranslations().done(function() {
    var $select, attr, attribute, item, items, j, len, match, options, realValue, selectize, sign;
    items = itemsFromFilter(getFilters());
    options = (function() {
      var j, len, ref, results1;
      results1 = [];
      for (j = 0, len = items.length; j < len; j++) {
        item = items[j];
        ref = /(\w+):([-=<>])(.*)/.exec(item), match = ref[0], attribute = ref[1], sign = ref[2], realValue = ref[3];
        results1.push(createOption(realValue, attribute, sign));
      }
      return results1;
    })();
    $select = (jQuery(selector)).selectize({
      options: options,
      items: items,
      delimiter: ';',
      create: function(input, callback) {
        return callback(createOption(input, 'details', '='));
      },
      persist: true,
      maxOptions: 20,
      maxItems: null,
      hideSelected: false,
      openOnFocus: false,
      closeAfterSelect: true,
      dropdownParent: 'body',
      searchField: ['realValue', 'display'],
      valueField: 'display',
      labelField: 'display',
      optgroups: (function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = attributes.length; j < len; j++) {
          attr = attributes[j];
          results1.push({
            value: attr
          });
        }
        return results1;
      })(),
      optgroupField: 'attribute',
      optgroupValueField: 'value',
      optgroupLabelField: 'value',
      render: {
        option: function(data, cb) {
          return optionTemplate(data);
        },
        item: function(data, cb) {
          return itemTemplate(data);
        },
        option_create: function(data, cb) {
          return detailsTemplate(data);
        }
      },
      onChange: function(value) {
        return null;
      },
      onItemAdd: function(value, element) {
        var filterString, filters, ref;
        if (inPopState) {
          return;
        }
        filters = getFilters();
        item = this.options[value];
        if (ref = item.attribute, indexOf.call(filters, ref) < 0) {
          filters[item.attribute] = [];
        }
        if (item.sign === '=') {
          filterString = item.realValue;
        } else {
          filterString = item.sign + item.realValue;
        }
        filters[item.attribute] = _.union(filters[item.attribute], [filterString]);
        return updateURL(filters);
      },
      onItemRemove: function(value) {
        var filterString, filters;
        if (inPopState) {
          return;
        }
        filters = getFilters();
        item = this.options[value];
        if (item.sign === '=') {
          filterString = item.realValue;
        } else {
          filterString = item.sign + item.realValue;
        }
        filters[item.attribute] = _.without(filters[item.attribute], filterString);
        if (item.attribute === 'details') {
          this.removeOption(value);
        }
        return updateURL(filters);
      },
      onDelete: function(values) {
        var value;
        while (values.length) {
          value = values.pop();
          this.removeItem(value);
          if (indexOf.call(this.options, value) >= 0 && this.options[value].attribute === 'details') {
            this.removeOption(value);
          }
        }
        return false;
      }
    });
    selectize = $select[0].selectize;
    for (j = 0, len = attributes.length; j < len; j++) {
      attribute = attributes[j];
      selectize.load(function(loadCB) {
        var attributePromise;
        attributePromise = getAttributeChoices(attribute);
        return attributePromise.done(function(data) {
          var k, key, l, len1, len2, ref, value, values;
          options = [];
          key = data.key;
          values = data[key];
          if (values !== null) {
            for (k = 0, len1 = values.length; k < len1; k++) {
              value = values[k];
              if (key !== 'status') {
                ref = ['=', '-', '<', '>'];
                for (l = 0, len2 = ref.length; l < len2; l++) {
                  sign = ref[l];
                  options.push(createOption(value, key, sign));
                }
              } else {
                options.push(createOption(value, key, '='));
              }
            }
          }
          return loadCB(options);
        });
      });
    }
    return (jQuery(window)).on('popstate', function(ev) {
      var data, k, l, len1, len2, newItems, oldItems, state, toAdd, toRemove;
      if (ev.originalEvent != null) {
        state = ev.originalEvent.state;
      } else {
        state = ev.state;
      }
      oldItems = selectize.items;
      newItems = itemsFromFilter(getFilters());
      toRemove = _.difference(oldItems, newItems);
      toAdd = _.difference(newItems, oldItems);
      inPopState = true;
      for (k = 0, len1 = toRemove.length; k < len1; k++) {
        item = toRemove[k];
        selectize.removeItem(item, true);
        if (item in selectize.options) {
          data = selectize.options[item];
          if (data.attribute === 'details') {
            selectize.removeOption(item);
          }
        }
      }
      for (l = 0, len2 = toAdd.length; l < len2; l++) {
        item = toAdd[l];
        selectize.addItem(item, true);
      }
      return inPopState = false;
    });
  });
};

exports._getAttributeChoices = getAttributeChoices;

exports._trimEmpty = trimEmpty;

exports._keyDifference = keyDifference;

exports._splitFilterString = splitFilterString;

exports._parseFilterString = parseFilterString;

exports.getFilters = getFilters;

exports.unParseFilters = unParseFilters;

exports.updateURL = updateURL;

exports.createFilterBar = createFilterBar;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
